import React from "react";
import { Users } from "../fasades/users";
import { PaymentStatus } from "../chatbot/api/llmapi";
import './paysuccess.css';
import { Conversation } from "../fasades/conversation";



type PaymentSuccessState = {
    status: PaymentStatus;
    attempts: number;
    checkoutId: string;
}

export class PaymentSuccess extends React.Component {

    state: PaymentSuccessState = {
        status: PaymentStatus.pending,
        attempts: 0,
        checkoutId: ""
    };

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const checkoutId = urlParams.get('session_id');

        this.setState({ checkoutId: checkoutId });
        this.checkPaymentStatus();
    }

    async fetchPaymentStatus() {
        return await Users.getPaymentStatus(this.state.checkoutId)
    };

    sleep(ms: number) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    async checkPaymentStatus() {
        const MAX_ATTEMPTS = 5;

        while (this.state.attempts < MAX_ATTEMPTS) {
            const response = await this.fetchPaymentStatus();

            if (response.status === PaymentStatus.paid || response.status === PaymentStatus.failed) {
                this.setState({ status: response.status});
                Conversation.fetchUserCredits(true);
                return;
            }

            let currentAttempts = this.state.attempts;
            this.setState({
                status: PaymentStatus.pending,
                attempts: currentAttempts + 1,
            });

            const delay = 2000 + this.state.attempts * 1500;

            await this.sleep(delay);
        }

        this.setState({ status: PaymentStatus.pending });
    };

    render() {
        const { status } = this.state;

        const statusClass = 
            status === PaymentStatus.pending ? 'status-pending' :
            status === PaymentStatus.paid ? 'status-success' :
            'status-failed';

        return (
        <div className="pay-success-container">
            <div className={`content ${statusClass}`}>

                {status === PaymentStatus.pending && (
                    <>
                        <h2>Payment Processing...</h2>
                        <p>Please wait while we confirm your payment.</p>
                    </>
                )}

                {status === PaymentStatus.paid && (
                    <>
                        <h2>Payment Successful</h2>
                        <p>Your order has been confirmed.</p>
                        <a href="/" className="link">Return to home</a>
                    </>
                )}

                {status === PaymentStatus.failed  && (
                    <>
                        <h2>Payment Failed</h2>
                        <p>Please try again or use a different payment method.</p>
                        <a href="/pay" className="link">Try again</a>
                    </>
                )}
            </div>
        </div>
        );
    }
}